import { z } from 'zod';

export const smsUsageSchema = z.object({
  /** References `location._id` */
  tenantId: z.string(),
  /**
   * The maximum number of SMS messages that can be sent per day, for this tenant.
   * `null` means no limit.
   **/
  smsDailyLimit: z.number().nullable().default(null),
  /**
   * The number of SMS messages sent today, for this tenant. Reset at midnight AEST.
   **/
  smsTodayUsage: z.number().default(0),
  /**
   * The number of SMS messages sent this month, for this tenant. Reset on the 1st of each month at midnight AEST.
   **/
  smsMonthlyUsage: z.number().default(0),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
});
export type SmsUsage = z.output<typeof smsUsageSchema>;

export const smsUsageCvxSchema = smsUsageSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
});
export type SmsUsageCvx = z.output<typeof smsUsageCvxSchema>;
